export default "__VITE_ASSET__C6e_2Ebk__"